<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" role="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">Checkbox</h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>

<div class="content">
  <ng-container *ngIf="isBrowser;else noJsContent">
    <h2>Checkbox Use Case 1 : Angular Form</h2>
    <form [formGroup]="form" (ngSubmit)="submitted = true" id="form1" novalidate>
      <maced-checkbox-group checkboxGroupId="checkboxGroupId1" label="Label" [required]="true" >
        <div class="c-input-outer__multiple-item" *ngFor="let data of Data; let i=index">
          <maced-checkbox [checkboxId]="data.name" [hasAriaLabel] = 'true' [value]="data.value" [label]="data.name" [required]="true" [hasButtonStyle]="false" formID="form1"
            [hasError]="(form.controls.checkArray.touched || submitted) && !!form.controls.checkArray.errors"
            [checked]="form.value.checkArray.includes(data.value)" (change)="onCheckboxChange($event)">
          </maced-checkbox>
        </div>
        <div class="c-input-outer__helper-text">
          This is helper text
        </div>
        <div class="c-input-outer__multiple-error" role="region" aria-live="polite" 
          *ngIf="(form.controls.checkArray.touched || submitted) && form.controls.checkArray.errors?.required">
          This field is required
        </div>
      </maced-checkbox-group>
      <div class="u-mt-16">
        <maced-button buttonId="buttonId1" label="Submit" form="form1" buttonType="submit"></maced-button>
      </div>
    </form>
    <p>
      Result:- {{ form.value.checkArray }}
    </p>

    <h2>Checkbox Use Case 2 : Disabled & Vertical State</h2>
    <form [formGroup]="form" (ngSubmit)="submitted = true" novalidate>
      <maced-checkbox-group checkboxGroupId="checkboxGroupId2" label="Label" [required]="true" [disabled]="true" 
        [isVertical]="true">
        <div class="c-input-outer__multiple-item" *ngFor="let data of Data2; let i=index">
          <maced-checkbox [checkboxId]="data.name" [value]="data.value" [label]="data.name" [required]="true" 
            [disabled]="true">
          </maced-checkbox>
        </div>
        <div class="c-input-outer__helper-text">
          This is helper text
        </div>
      </maced-checkbox-group>
    </form>

    <h2>Checkbox Use Case 3 : Error</h2>
    <maced-checkbox checkboxId="checkboxNgModelError" name="checkboxNgModelError" value="TestValue" label="label"
      [(ngModel)]="checkboxNgModelError" [hasAriaLabel]="true" [hasError]="true">
    </maced-checkbox>
    <div class="c-input-group__error"  role="alert"> Error message will go here </div>
    <p>
      Result:- {{ checkboxNgModelError }}
    </p>
  </ng-container>

  <ng-template #noJsContent>
    <form action="/checkbox" method="get" id="form3" >
      <maced-checkbox checkboxId="checkboxNgModel" name="checkboxNgModel" value="TestValue" label="label" formID="form3"
        [checked]="checkboxNgModel === 'TestValue'">
      </maced-checkbox>
      <maced-button buttonId="buttonId2" form="form3" label="Submit" buttonType="submit"></maced-button>
    </form>
    <p>
      Result:- {{ checkboxNgModel }}
    </p>
  </ng-template>


  <h2>Checkbox Use Case 4 : Button style checkbox</h2>
  <form [formGroup]="formButton" (ngSubmit)="submitted = true" id="form4"  novalidate>
    <maced-checkbox-group checkboxGroupId="checkboxGroupId3" label="Label" [required]="true" [isVertical]="true">
      <div class="c-input-outer__multiple-item" *ngFor="let data of buttonStyle; let i=index">
        <maced-checkbox [checkboxId]="data.add" [value]="data.value" [label]="ariaLabel" [hasCheckboxLabel]="true" [required]="true" [hasButtonStyle]="true" formID="form4"
          [hasError]="(formButton.controls.checkButtonArray.touched || submitted) && !!formButton.controls.checkButtonArray.errors"
          [checked]="formButton.value.checkButtonArray.includes(data.value)" (change)="onButtonCheckboxChange($event,i)">
        </maced-checkbox>
      </div>
      <div class="c-input-outer__helper-text">
        This is helper text
      </div>
      <div class="c-input-outer__multiple-error" role="alert"
        *ngIf="(formButton.controls.checkButtonArray.touched || submitted) && formButton.controls.checkButtonArray.errors?.required">
        This field is required
      </div>
    </maced-checkbox-group>
    <div class="u-mt-16">
      <maced-button buttonId="buttonId2" form="form4" label="Submit" buttonType="submit"></maced-button>
    </div>
  </form>
  

</div>